import * as t from 'io-ts';

import {makeEnumRuntimeType} from '../../../models/api/apiTypes';
import {RRecentConversations} from '../../../models/api/recentConversationsModel';

/*
 * Runtime types.
 */

export enum RecentCommunicationsBannerStatusesEnum {
  VISIBLE = 'VISIBLE',
  DISMISSED = 'DISMISSED',
  BANNER_CLICKED = 'BANNER_CLICKED',
  HIGHLIGHT_VIEWED = 'HIGHLIGHT_VIEWED',
}

const RRecentCommunications = t.intersection([
  // Fetched from the backend
  RRecentConversations,
  // Additional metadata on the frontend for caching + tracking the status of the banner
  t.type({
    requestedAt: t.number,
    bannerStatus: makeEnumRuntimeType(RecentCommunicationsBannerStatusesEnum),
  }),
]);

// Maps a contact uid to their recent communications
export const RRecentCommunicationsState = t.dictionary(t.string, RRecentCommunications);

/*
 * Types.
 */

export type RecentCommunications = t.TypeOf<typeof RRecentCommunications>;
export type RecentCommunicationsState = t.TypeOf<typeof RRecentCommunicationsState>;
